module.exports = "<md-icon class=\"material-icons material-icons--help\" aria-label=help> help <md-tooltip class=dt-theme>{{::$ctrl.message}}</md-tooltip> </md-icon> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/help-icon/help-icon.html
// module id = 5qCE
// module chunks = 1